/**
 * @package services-settings
 */
// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default {
    data() {
        return {
            isCreate: true,
        };
    },
};
